import script from "./AppConfiguration.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppConfiguration.vue?vue&type=script&setup=true&lang=ts"

import "./AppConfiguration.vue?vue&type=style&index=0&id=37ffca1c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37ffca1c"]])

export default __exports__